import Modal from './modal';

export default function loginFormControl() {
  $('.js-modal-forgotten').on('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    new Modal({
      body: `<h2 class="green">Forgotten your login details?</h2>\n
             <p>To reset your login details you need <br />your mobile phone to hand.</p>`,
      fnContinue: () => {
        window.location.href = forgottenUrl;
      },
    });
  });

  $(document.body).on('click', '.top-up-btn', function (event) {
   event.preventDefault();
   event.stopPropagation();
    $('.top-up-btn').not($(this)).removeClass('active');
    $('.top-up-btn-input').removeClass('active');
    $(this).addClass('active');
    $('input[name=top_up_value]').val($(this).data('top-up'));
  });

    $(document.body).on('click focus', '.top-up-btn-input', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $('.top-up-btn').removeClass('active');
        $(this).addClass('active');
        $('input[name=top_up_value]').val(isNaN(parseInt($(this).val())) ? 0 : parseInt($(this).val()));
    });

    $(document.body).on('keyup', '.top-up-btn-input', function (event) {
        event.preventDefault();
        event.stopPropagation();
        let currentVal = isNaN(parseInt($(this).val())) ? 0 : parseInt($(this).val());
        if(currentVal > 1500000) {
            currentVal = 1500000;
            $(this).val(currentVal);
        }
        if(currentVal < 1) {
            $(this).val(currentVal);
        }
       $('input[name=top_up_value]').val(currentVal);
    });

}
